module.exports = __webpack_public_path__ + "static/media/_panama.c8526ff0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_panama.svg
// module id = 2344
// module chunks = 7